<template>
  <el-dialog class="setting" title="设置" :visible.sync="visible" width="420px" :before-close="onClose">
    <el-form :model="userInfo" label-width="80px" :rules="formRules" ref="settingForm" size="small">
      <el-form-item label="头像" style="margin-bottom: 0 !important;">
        <file-upload class="avatar-uploader" :action="imageAction" :showLoading="true" :maxSize="maxSize"
          @success="onUploadSuccess" :fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp']">
          <img v-if="userInfo.headImage" :src="userInfo.headImage" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </file-upload>
      </el-form-item>
      <el-form-item label="用户名">
        <el-input disabled v-model="userInfo.userName" autocomplete="off" size="small"></el-input>
      </el-form-item>
      <el-form-item label="聊天号" prop="userCode">
        <el-input 
          v-model="userInfo.userCode" 
          autocomplete="off" 
          size="small"
          maxlength="20"
          placeholder="请输入聊天号（6-20位数字字母组合）"
          @input="onUserCodeInput"
          @blur="validateUserCode"
        ></el-input>
      </el-form-item>
      <el-form-item prop="nickName" label="昵称">
        <el-input v-model="userInfo.nickName" autocomplete="off" size="small"></el-input>
      </el-form-item>
      <el-form-item label="性别">
        <el-radio-group v-model="userInfo.sex">
          <el-radio :label="0">男</el-radio>
          <el-radio :label="1">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="个性签名">
        <el-input type="textarea" v-model="userInfo.signature" :rows="3"></el-input>
      </el-form-item>
      
      <!-- 通知设置分割线 -->
      <el-divider content-position="left">通知设置</el-divider>
      
      <el-form-item label="桌面通知">
        <el-switch
          v-model="notificationSettings.desktop"
          active-text="开启"
          inactive-text="关闭"
          @change="onNotificationSettingChange">
        </el-switch>
        <div style="margin-top: 5px;">
          <div style="font-size: 12px; color: #999;">
            页面不在前台时显示桌面通知
          </div>
          <el-button 
            size="mini" 
            type="text" 
            @click="testDesktopNotification"
            :disabled="!notificationSettings.desktop"
            style="padding: 0; margin-top: 5px;">
            测试桌面通知
          </el-button>
        </div>
      </el-form-item>
      
      <el-form-item label="声音提示">
        <el-switch
          v-model="notificationSettings.sound"
          active-text="开启"
          inactive-text="关闭"
          @change="onNotificationSettingChange">
        </el-switch>
        <div style="font-size: 12px; color: #999; margin-top: 5px;">
          收到新消息时播放提示音
        </div>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="onClose()">取 消</el-button>
      <el-button type="primary" @click="onSubmit()">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import FileUpload from "../common/FileUpload.vue";

export default {
  name: "setting",
  components: {
    FileUpload
  },
  data() {
    return {
      userInfo: {},
      maxSize: 5 * 1024 * 1024,
      action: "/image/upload",
      originalUserCode: '',
      notificationSettings: {
        desktop: true,
        sound: true
      }
    }
  },
  methods: {
    // 验证聊天号规则（用于el-form验证）
    validateUserCodeRule(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入聊天号'));
        return;
      }
      
      if (value.length < 6) {
        callback(new Error('聊天号至少6个字符'));
        return;
      }
      
      const regex = /^[a-zA-Z0-9]+$/;
      if (!regex.test(value)) {
        callback(new Error('聊天号只能包含数字和字母'));
        return;
      }
      
      if (this.isSimpleUserCode(value)) {
        callback(new Error('聊天号过于简单，请设置复杂一些'));
        return;
      }
      
      callback();
    },
    
    // 检查聊天号是否过于简单
    isSimpleUserCode(userCode) {
      // 连续数字
      const consecutiveNumbers = /^(\d)\1{5,}$|^123456|^654321|^111111|^000000/;
      if (consecutiveNumbers.test(userCode)) {
        return true;
      }
      
      // 连续字母
      const consecutiveLetters = /^(a)\1{5,}$|^abcdef|^fedcba|^aaaaaa/i;
      if (consecutiveLetters.test(userCode)) {
        return true;
      }
      
      // 常见简单组合
      const simplePatterns = [
        '123456', '654321', 'abcdef', 'fedcba',
        '111111', '222222', '333333', '444444', '555555',
        '666666', '777777', '888888', '999999', '000000',
        'aaaaaa', 'bbbbbb', 'cccccc', 'dddddd', 'eeeeee',
        'ffffff', 'gggggg'
      ];
      
      return simplePatterns.some(pattern => 
        userCode.toLowerCase().includes(pattern)
      );
    },
    
    // 检查聊天号唯一性
    async checkUserCodeAvailable(userCode) {
      try {
        const result = await this.$http({
          url: '/user/check-usercode',
          method: 'get',
          params: { userCode }
        });
        return result.available;
      } catch (error) {
        console.error('检查聊天号唯一性失败:', error);
        return false;
      }
    },
    
    // 验证聊天号
    validateUserCode() {
      this.$refs.settingForm.validateField('userCode');
    },
    
    // 聊天号输入时清除错误提示
    onUserCodeInput() {
      this.$refs.settingForm.clearValidate('userCode');
    },

    onClose() {
      this.$emit("close");
    },
    async onSubmit() {
      this.$refs['settingForm'].validate(async (valid) => {
        if (!valid) {
          return false;
        }
        
        // 如果聊天号有变化，检查唯一性
        if (this.userInfo.userCode !== this.originalUserCode) {
          this.$loading({ text: '检查聊天号...' });
          
          const isAvailable = await this.checkUserCodeAvailable(this.userInfo.userCode);
          this.$loading().close();
          
          if (!isAvailable) {
            this.$message.error('该聊天号已被使用');
            return;
          }
        }
        
        try {
          this.$loading({ text: '保存中...' });
          
          await this.$http({
            url: "/user/update",
            method: "put",
            data: this.userInfo
          });
          
          this.$store.commit("setUserInfo", this.userInfo);
          this.originalUserCode = this.userInfo.userCode;
          this.$emit("close");
          this.$loading().close();
          this.$message.success("修改成功");
        } catch (error) {
          this.$loading().close();
          this.$message.error("修改失败");
        }
      });
    },
    onUploadSuccess(data, file) {
      this.userInfo.headImage = data.originUrl;
      this.userInfo.headImageThumb = data.thumbUrl;
    },
    // 处理通知设置变更
    onNotificationSettingChange() {
      // 保存到localStorage
      localStorage.setItem('im-notification-settings', JSON.stringify(this.notificationSettings));
      
      // 如果开启桌面通知，请求权限
      if (this.notificationSettings.desktop) {
        this.requestNotificationPermission();
      }
      
      // 触发事件通知父组件设置已更改
      this.$emit('notification-settings-changed', this.notificationSettings);
    },
    // 请求桌面通知权限
    async requestNotificationPermission() {
      if (!('Notification' in window)) {
        this.$message.warning('您的浏览器不支持桌面通知');
        this.notificationSettings.desktop = false;
        return false;
      }
      
      if (Notification.permission === 'granted') {
        return true;
      }
      
      if (Notification.permission !== 'denied') {
        const permission = await Notification.requestPermission();
        if (permission !== 'granted') {
          this.$message.warning('桌面通知权限被拒绝，将无法显示桌面通知');
          this.notificationSettings.desktop = false;
        }
        return permission === 'granted';
      } else {
        this.$message.warning('桌面通知权限被拒绝，请在浏览器设置中手动开启');
        this.notificationSettings.desktop = false;
        return false;
      }
    },
    // 加载通知设置
    loadNotificationSettings() {
      const savedSettings = localStorage.getItem('im-notification-settings');
      if (savedSettings) {
        try {
          this.notificationSettings = JSON.parse(savedSettings);
        } catch (e) {
          console.error('加载通知设置失败:', e);
        }
      }
    },
    // 测试桌面通知
    testDesktopNotification() {
      if (!('Notification' in window)) {
        this.$message.error('您的浏览器不支持桌面通知');
        return;
      }
      
      if (Notification.permission !== 'granted') {
        this.$message.warning('请先允许桌面通知权限');
        return;
      }
      
      const notification = new Notification('盒子IM 通知测试', {
        body: '如果您看到这条通知，说明桌面通知功能正常工作！',
        icon: '/logo.png',
        badge: '/logo.png',
        tag: 'test-notification',
        requireInteraction: false
      });
      
      // 点击通知时关闭
      notification.onclick = () => {
        notification.close();
      };
      
      // 3秒后自动关闭
      setTimeout(() => {
        notification.close();
      }, 3000);
      
      this.$message.success('测试通知已发送，请查看桌面通知');
    }
  },
  props: {
    visible: {
      type: Boolean
    }
  },
  computed: {
    imageAction() {
      return `/image/upload`;
    },
    formRules() {
      return {
        nickName: [{
          required: true,
          message: '请输入昵称',
          trigger: 'blur'
        }],
        userCode: [{
          required: true,
          message: '请输入聊天号',
          trigger: 'blur'
        }, {
          validator: this.validateUserCodeRule,
          trigger: 'blur'
        }]
      };
    }
  },
  watch: {
    visible: function (newData, oldData) {
      if (newData) {
        // 深拷贝
        let mine = this.$store.state.userStore.userInfo;
        this.userInfo = JSON.parse(JSON.stringify(mine));
        // 保存原始聊天号用于对比
        this.originalUserCode = this.userInfo.userCode;
        // 加载通知设置
        this.loadNotificationSettings();
      }
    }
  },
  mounted() {
    // 组件挂载时加载通知设置
    this.loadNotificationSettings();
  }
}
</script>

<style lang="scss">
.setting {
  .el-form {
    padding: 10px 0 0 10px;
  }

  .avatar-uploader {
    --width: 112px;

    .el-upload {
      border: 1px dashed #d9d9d9 !important;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .el-upload:hover {
      border-color: #409EFF;
    }

    .avatar-uploader-icon {
      font-size: 24px;
      color: #8c939d;
      width: var(--width);
      height: var(--width);
      line-height: var(--width);
      text-align: center;
    }

    .avatar {
      width: var(--width);
      height: var(--width);
      display: block;
    }
  }
}
</style>
